<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="svgContent"></div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'

type Props = {
  src: string
}

const props = defineProps<Props>()

const svgContent = ref<string | null>(null)

onMounted(async () => {
  try {
    const svgPath = new URL(`../assets/icons/${props.src}.svg`, import.meta.url).href
    const response = await fetch(svgPath)
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    svgContent.value = await response.text()
  } catch (error) {
    svgContent.value = ''
    console.error('There was a problem fetching the SVG:', error)
  }
})
</script>

<style lang="scss" scoped>
div {
  display: flex;
}
</style>
